import { Component, EventEmitter, Input, OnChanges, OnInit, Output,SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-time-range-picker',
  templateUrl: './time-range-picker.component.html',
  styleUrls: ['./time-range-picker.component.scss']
})
export class TimeRangePickerComponent implements OnInit, OnChanges {

  @Input() timeRangeControl: FormControl;
  @Input() givenStartTimeAt24: string = "00:00";
  @Input() givenEndTimeAt24: string = "23:59";
  @Input() timezone: string;
  @Input() isSameDateRange: boolean = false;
  @Input() isTwelveHr: boolean = false;
  
  @Output() valueChanged: EventEmitter<void> = new EventEmitter<void>();
  
  tempTimeRange: FormGroup = new FormGroup({
    startTime: new FormControl(this.get12HrTime(this.givenStartTimeAt24)),
    endTime: new FormControl(this.get12HrTime(this.givenEndTimeAt24)),
  })
  
  isOpen: boolean = false;
  isRangeValid: boolean = true;
  timeFormat: string;
  isEnteredTimeValid: boolean = true;

  constructor() { }

  ngOnInit(): void {
    this.timeFormat = this.isTwelveHr ? 'hh:mm A': 'HH:mm';
    this.timeRangeControl.setValue({
      startTime: this.givenStartTimeAt24,
      endTime: this.givenEndTimeAt24,
    });
  }

  ngOnChanges(changes: SimpleChanges){
    if(this.isSameDateRange){
      this.timeRangeControl.setValue({
        startTime: this.givenStartTimeAt24,
        endTime: this.givenEndTimeAt24,
      });
    }
  }

  handleTimeRangeChange(timeRange: any){
    this.isEnteredTimeValid = moment(this.tempTimeRange.get('startTime').value, this.timeFormat).isValid() && moment(this.tempTimeRange.get('endTime').value, this.timeFormat).isValid();   
    if(this.isSameDateRange){
      this.validateRange(this.tempTimeRange.get('startTime').value, this.tempTimeRange.get('endTime').value);
    }
  }

  setTimeRange() {
    this.timeRangeControl.setValue({
      startTime: this.isTwelveHr ? moment(this.tempTimeRange.value?.startTime || '12:00 AM', 'hh:mm A').format('HH:mm') : this.tempTimeRange.value?.startTime,
      endTime: this.isTwelveHr ? moment(this.tempTimeRange.value?.endTime || '11:59 PM', 'hh:mm A').format('HH:mm') : this.tempTimeRange.value?.endTime
    });
    this.valueChanged.emit();
    this.isOpen = false;
  }

  validateRange(start: string, end: string) {
    this.isRangeValid = moment(start, this.timeFormat).isBefore(moment(end, this.timeFormat));
  }

  get12HrTime(timeAt24: string) {
    return moment(timeAt24, 'HH:mm').format("hh:mm A");
  }

  openPicker(){
    this.tempTimeRange.patchValue({
      startTime: this.isTwelveHr ? this.get12HrTime(this.timeRangeControl.value?.startTime || '00:00') : this.timeRangeControl.value?.startTime || '00:00',
      endTime: this.isTwelveHr ? this.get12HrTime(this.timeRangeControl.value?.endTime || '23:59') : this.timeRangeControl.value?.endTime || '23:59'
    });
    // if(this.isSameDateRange){
    //   this.validateRange(this.tempTimeRange.get('startTime').value, this.tempTimeRange.get('endTime').value);
    // }
    this.isOpen = true;
  }

  closePicker(){
     this.tempTimeRange.patchValue({
      startTime: this.isTwelveHr ? this.get12HrTime(this.timeRangeControl.value?.startTime || '00:00') : this.timeRangeControl.value?.startTime || '00:00',
      endTime: this.isTwelveHr ? this.get12HrTime(this.timeRangeControl.value?.endTime || '23:59') : this.timeRangeControl.value?.endTime || '23:59'
    });
    this.isRangeValid = true;
    this.isEnteredTimeValid = true;
    this.isOpen = false;
  }

}
